import ResetPasswordEmailLink from 'views/pages/Auth/ResetPasswordEmailLink';
import SsoLogin from '../legacy/pages/SsoLogin';
import AppOrchard from '../legacy/pages/AppOrchard';
import Login from '../legacy/pages/Login';
import RequestNewPassword from '../legacy/pages/RequestNewPassword';
import ResetPassword from '../legacy/pages/ResetPassword';

export const ROOT_PATH = {
  LOGIN_SSO: '/sso',
  APP_ORCHARD_SSO: '/appOrchard',
  LOGIN: '/login',
  REQUEST_NEW_PASSWORD: '/request-new-password',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_EMAIL_LINK: '/reset_password',
};

const routes = [
  {
    exact: true,
    path: `${ROOT_PATH.APP_ORCHARD_SSO}`,
    component: AppOrchard,
  },
  {
    exact: true,
    path: `${ROOT_PATH.LOGIN_SSO}/:ssoRoute/:teamId`,
    component: SsoLogin,
  },
  {
    exact: true,
    path: ROOT_PATH.LOGIN,
    component: Login,
  },
  {
    exact: true,
    path: ROOT_PATH.REQUEST_NEW_PASSWORD,
    component: RequestNewPassword,
  },
  {
    exact: true,
    path: `${ROOT_PATH.RESET_PASSWORD}/:token`,
    component: ResetPassword,
  },
  {
    exact: true,
    path: `${ROOT_PATH.RESET_PASSWORD_EMAIL_LINK}/:token`,
    component: ResetPasswordEmailLink,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/authRoutes.jsx